<script setup>
import useInventoryTable from "./hooks/useInventoryTable";
import Adjust from "./adjust.vue";
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import useCateGoryList from "../../hooks/useCategoryList";
import useStashList from "../../hooks/useStashList";
import useDict from "../../hooks/useDict";

const { categoryList } = useCateGoryList();
const { stashList } = useStashList();
const { result } = useDict();

const alarmOptions = [
  {
    label: "未预警",
    value: 0,
  },
  {
    label: "低于下限预警",
    value: 1,
  },
  {
    label: "高于上限预警",
    value: 2,
  },
];

const defaultProps = {
  label: "node",
  disabled: (data) => {
    return data.parentId == "0";
  },
};

const isActive = (row) => {
  if (row.totalQuantity < row.lowerLimit || row.totalQuantity > row.upperLimit)
    return true;
  return false;
};
const deviationCom = (row) => {
  let count = "-";
  try {
    switch (row.alarm.value) {
      case 0:
        count = "-";
        break;
      case 1:
        count = row.lowerLimit - row.totalQuantity;
        break;
      case 2:
        count = row.totalQuantity - row.upperLimit;
        break;
    }
  } catch (error) {
    count = "-";
  }
  return count;
};

const {
  searchRef,
  searchData,
  columns,
  handleSortChange,
  totalInventoryCount,
  tableData,
  tableLoading,
  pages,
  handleSizeChange,
  handleCurrentChange,
  indexMethod,
  editRef,
  getList,
  handleReset,
  handleAdjust,
  handleExport,
} = useInventoryTable();

const route = useRoute();
onMounted(() => {
  // 消息中心跳转过来
  const refKey = route.query.refKey;
  // 使用参数
  if (refKey) {
    searchData.number = refKey;
  }
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '库存管理' }">
    <template #header-btn></template>
    <template #search>
      <el-form
        :model="searchData"
        ref="searchRef"
        label-width="80px"
        class="search-form"
      >
        <el-row :gutter="10">
          <el-form-item label="物料名称:" prop="name">
            <el-input v-model="searchData.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="物料编号:" prop="number">
            <el-input v-model="searchData.number" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="物料类别:" prop="categoryIdList">
            <el-tree-select
              v-model="searchData.categoryIdList"
              multiple
              :data="categoryList"
              :render-after-expand="false"
              show-checkbox
              :props="defaultProps"
              :check-strictly="true"
              node-key="id"
            />
          </el-form-item>
          <el-form-item label="品牌:" prop="brand">
            <el-select
              v-model="searchData.brand"
              placeholder="请输入"
              filterable
            >
              <el-option
                v-for="item in result.brand"
                :key="item.id"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="规格型号:" prop="model">
            <el-select
              v-model="searchData.model"
              placeholder="请输入"
              filterable
            >
              <el-option
                v-for="item in result.model"
                :key="item.id"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="仓库:" prop="warehouseIdList">
            <el-select
              v-model="searchData.warehouseIdList"
              placeholder="请输入"
              multiple
            >
              <el-option
                v-for="item in stashList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="预警类型:" prop="alarm">
            <el-select
              v-model="searchData.alarm"
              placeholder="请输入"
              filterable
            >
              <el-option
                v-for="item in alarmOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="库存数量:">
            <div style="display: flex">
              <el-input-number
                style="width: 83px"
                :controls="false"
                v-model="searchData.lowerQuantity"
                placeholder="最小值"
              ></el-input-number>
              <span style="margin: 0 5px">-</span>
              <el-input-number
                style="width: 83px"
                :controls="false"
                v-model="searchData.upperQuantity"
                placeholder="最大值"
              ></el-input-number>
            </div>
          </el-form-item>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <el-button icon="Download" @click="handleExport()">导出</el-button>
      <el-button type="primary" icon="Search" @click="getList()"
        >查询</el-button
      >
      <el-button icon="Refresh" @click="handleReset()">重置</el-button>

      <div class="total">
        <span>物料数: {{ pages.total || 0 }}</span>
        <span class="price">物料库存总数: {{ totalInventoryCount || 0 }}</span>
      </div>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
        @sort-change="handleSortChange"
      >
        <el-table-column
          label="序号"
          type="index"
          width="55"
          fixed
          :index="indexMethod"
        />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :show-overflow-tooltip="item.showOverflowTooltip"
            :min-width="item.minWidth"
            :width="item.width"
            :sortable="item.isCustomSort ? 'custom' : isSort ? true : false"
          >
            <template #default="{ row }">
              <span
                v-if="item.prop == 'totalQuantity'"
                :class="{ active: isActive(row) }"
              >
                {{ row[item.prop] ?? "-" }}
              </span>

              <span v-else-if="item.prop == 'alarm'">
                {{ row[item.prop]?.desc ?? "-" }}
              </span>

              <span v-else-if="item.prop == 'deviation'">
                <span>
                  {{ deviationCom(row) }}
                </span>
                <span
                  v-if="row.alarm?.value"
                  :class="[row.alarm?.value === 1 ? 'down' : 'up']"
                >
                  {{ row.alarm?.value === 1 ? "↓" : "↑" }}</span
                >
              </span>

              <span
                v-else-if="
                  ['lockInventory', 'upperLimit', 'lowerLimit'].includes(
                    item.prop
                  )
                "
                >{{ row[item.prop] ?? "-" }}</span
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>

        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 'detail')"
              >详情</el-button
            >
            <el-button type="primary" link @click="handleAdjust(row, 'edit')"
              >库存预警设置</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <Adjust ref="editRef" @after-save="getList" />
</template>

<style scoped lang="less">
.search-form {
  .el-input,
  .el-select {
    width: 180px;
    margin-right: 10px;
  }
}
.active {
  color: #f56c6c;
}

.down {
  color: #0089ff;
}
.up {
  color: red;
}
.total {
  display: inline-block;
  color: #409eff;
  margin-left: 20px;
  font-size: 12px;
  .price {
    margin-left: 20px;
  }
}
</style>
